module.exports = __webpack_public_path__ + "img/IMG_3539_L_WoodMatted.81a6de09.jpg";